// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"e7ef0341","83":"12a9150c","421":"c8dca5eb","422":"3835472b","588":"8e36f2bd","675":"ce567f93","679":"83636e98","711":"aef6edbc","726":"bddca1fe","791":"b7c5008e","926":"7e95d8c8"}[chunkId] + ".chunk.js";
};